export default __webpack_public_path__ + "static/media/prabin.0382bf17.jpg";